// extracted by mini-css-extract-plugin
module.exports = {"base":"style_base__PJxWO","Description":"style_Description__Y6LYh","Card":"style_Card__3HHjI"};